import { useState } from 'react';
import { UploadXmlUseCase } from '../../application/useCases';
import { getXmlRecusaMensagem, isXmlRecusadoNoEnvio } from '../../shared/utils';
import { useApp } from '../contexts';

export interface XmlUploadLocal {
    xmlId: number;
    motivo: string | null;
}

export const useXmlUpload = (token: string | null) => {
    const { showError, showSuccess } = useApp();
    // XMLs enviados nesta sessão, até a lista do back refletir o envio
    const [xmlUploads, setXmlUploads] = useState<Map<number, XmlUploadLocal>>(new Map());

    const uploadXml = async (file: File, transactionId: number): Promise<boolean> => {
        if (!token) {
            showError('Token não encontrado. Por favor, recarregue a página.');
            return false;
        }

        const validTypes = ['text/xml', 'application/xml', 'application/xhtml+xml'];
        const isValidType = validTypes.includes(file.type) || file.name.toLowerCase().endsWith('.xml');

        if (!isValidType) {
            showError('Por favor, selecione um arquivo XML válido.');
            return false;
        }

        try {
            const useCase = new UploadXmlUseCase();
            const xmlContent = await useCase.execute(file);

            const normalizedXml = xmlContent
                .replace(/\r\n/g, '')
                .replace(/\n/g, '')
                .replace(/\r/g, '')
                .replace(/>\s+</g, '><')
                .trim();

            const xml = await useCase.uploadToTransaction(transactionId, normalizedXml, token);
            const motivo = xml.mig_xml_status ?? null;

            setXmlUploads(prev => new Map(prev).set(transactionId, { xmlId: xml.mig_xml_id, motivo }));

            if (isXmlRecusadoNoEnvio(motivo)) {
                showError(getXmlRecusaMensagem(motivo));
                return false;
            }

            showSuccess('XML anexado com sucesso!');
            return true;
        } catch (error) {
            const message = error instanceof Error ? error.message : 'Erro ao enviar XML';
            showError(message);
            return false;
        }
    };

    return {
        uploadXml,
        xmlUploads,
    };
};
